(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('OfficeHoursService', OfficeHoursService)

  OfficeHoursService.$inject = ['$resource']

  function OfficeHoursService ($resource) {
    return $resource(apiUrl + '/office-hours', {}, {
      all: { method: 'GET', params: {}, isArray: true },
      save: { method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false }
    })
  }
})();
